module.exports = __webpack_public_path__ + "static/media/ellipse5.e22852ea.png";